import type { ModalCerrarSesionProps } from "../../core/types/tsx/components/modals/ModalCerrarSesion.types";
import { X } from 'lucide-react'

export function ModalCerrarSesion({
  open,
  onClose,
  onConfirm,
  onCancel,
  title = 'Cerrar Sesión',
  message = '¿Estás seguro de que quieres cerrar sesión?',
}: ModalCerrarSesionProps) {
  if (!open) return null

  const handleConfirm = () => {
    onConfirm?.()
    onClose()
  }

  const handleCancel = () => {
    onCancel?.()
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="relative w-full max-w-sm rounded-2xl bg-white px-6 py-5 soft-border card-shadow">
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar"
          className="absolute right-4 top-4 rounded-full p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700 cursor-pointer"
        >
          <X className="h-4 w-4" />
        </button>

        <h2 className="text-base font-semibold text-slate-900">{title}</h2>
        <p className="mt-2 text-xs text-slate-500">{message}</p>

        <div className="mt-6 flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={handleCancel}
            className="flex-1 rounded-full border border-primary px-4 py-2 text-xs font-semibold text-primary transition hover:bg-primary/10 cursor-pointer"
          >
            No
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="flex-1 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-white transition hover:bg-primary-hover cursor-pointer"
          >
            Sí
          </button>
        </div>
      </div>
    </div>
  )
}


